// Tradução única dos erros ao terminar um jogo (contrato P0). Pura: não conhece
// axios nem React — recebe { status?, data? } (status ausente = rede) ou o
// resultado { action: false } de um save.
export type FinishErrorKind =
  | 'already_scored'
  | 'free_limit'
  | 'tournament_closed'
  | 'requires_join'
  | 'requires_premium'
  | 'unknown';

export interface FinishErrorView {
  kind: FinishErrorKind;
  message: string;
}

export interface FinishErrorInput {
  status?: number;
  data?: unknown;
}

export const FINISH_ERROR_MESSAGES: Record<FinishErrorKind, string> = {
  already_scored: 'Você já pontuou neste jogo. Pode continuar jogando à vontade.',
  free_limit: 'Você atingiu o limite de passatempos gratuitos do mês. Assine para continuar pontuando.',
  tournament_closed: 'Este torneio não está aberto agora.',
  requires_join: 'Inscreva-se no torneio para pontuar.',
  requires_premium: 'Este torneio é exclusivo para assinantes.',
  unknown: 'Não foi possível salvar seu resultado. Tente de novo.',
};

export const SAVE_REJECTED = 'save_rejected';

const REASONS: readonly FinishErrorKind[] = ['tournament_closed', 'requires_join', 'requires_premium'];

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

function view(kind: FinishErrorKind): FinishErrorView {
  return { kind, message: FINISH_ERROR_MESSAGES[kind] };
}

export function translateFinishError(input: FinishErrorInput | { action: false }): FinishErrorView {
  const raw = input as Record<string, unknown>;
  const bareSave = 'action' in raw && !('data' in raw) && !('status' in raw);
  const status = bareSave ? undefined : (raw.status as number | undefined);
  const data: unknown = bareSave ? raw : raw.data;

  // 1. { action: false }
  if (isRecord(data) && data.action === false) return view('already_scored');

  // 2. reason do gate de torneio
  if (isRecord(data) && typeof data.reason === 'string' && REASONS.includes(data.reason as FinishErrorKind)) {
    return view(data.reason as FinishErrorKind);
  }

  // 3/4. texto (data.message ou data.msg, string, minúsculas)
  const text = isRecord(data)
    ? [data.message, data.msg].find((t): t is string => typeof t === 'string')
    : undefined;
  const lower = (text ?? '').toLowerCase();
  if (lower.includes('limite de passatempos gratuitos') || lower.includes('faça um upgrade')) {
    return view('free_limit');
  }
  if (lower.includes('já pontuou') || lower.includes('já possui progresso')) {
    return view('already_scored');
  }

  // 5. status 409
  if (status === 409) return view('tournament_closed');

  // 6.
  return view('unknown');
}

/** Converte o que o `catch` recebeu no input da tradução. */
export function finishErrorInputFrom(error: unknown): FinishErrorInput {
  if (isRecord(error) && error.kind === SAVE_REJECTED) return { data: error.data };
  if (isRecord(error) && isRecord(error.response)) {
    const { status, data } = error.response;
    return { status: typeof status === 'number' ? status : undefined, data };
  }
  return {};
}

/** `sudoku_progresso`/`wordsearch_progresso` respondem 200 { action:false } quando já finalizado. */
export function throwIfRejected(result: unknown): void {
  if (isRecord(result) && result.action === false) {
    throw Object.assign(new Error('save rejected'), { kind: SAVE_REJECTED, data: result });
  }
}
